/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global console, document, Excel, Office */
import AuthenticationController from "./authenticationController"
import SyncController from "./syncController";

let ddlProject: HTMLSelectElement; 
let authController: AuthenticationController
let syncController: SyncController;
let eventHost: HTMLElement;

Office.onReady(info => {
  if (info.host === Office.HostType.Excel) {
    eventHost = document.querySelector("body") as HTMLElement;
    ddlProject = document.getElementById("f19-project") as HTMLSelectElement;
    authController = new AuthenticationController(document.querySelector(".js-login-section") as HTMLElement, eventHost);
    syncController = new SyncController(document.querySelector(".js-sync") as HTMLElement, eventHost, authController);
    (document.querySelector(".js-splash") as HTMLElement).hidden = true;
  }
});

